import { observer } from 'mobx-react';
import { ContactDetailsSidebar } from 'Modules/contacts/sidePanel/components/ContactDetailsSidebar';
import { EntityProfileSidebar } from 'Modules/contacts/sidePanel/components/EntityProfileSidebarV2';
import { GroupDetailsSidebar } from 'Modules/contacts/sidePanel/components/GroupDetailsSidebar';
import React from 'react';
import { useEntitySidebar } from './hooks/useEntitySidebar';
import { EntityProfileV2Props } from './index.types';

/**
 * EntityProfileV2 container component that manages entity profile data and sidebar presentation.
 *
 * This container orchestrates the display of entity profile information in a sidebar format.
 *
 */
export const EntityProfileV2 = observer(({ hidden }: EntityProfileV2Props) => {
  const {
    contact,
    navigatedContacts,
    sidebarToShow,
    closePanel,
    setNavigatedContacts,
  } = useEntitySidebar();

  // Don't render if sidebar is not visible
  if (!sidebarToShow) {
    return null;
  }

  return (
    <>
      {sidebarToShow === 'oneOnOne' && (
        <EntityProfileSidebar
          closePanel={closePanel}
          openContactDetails={(contact) => {
            setNavigatedContacts([...navigatedContacts, contact]);
          }}
          hidden={navigatedContacts.length > 0 || hidden}
        />
      )}

      {sidebarToShow === 'group' && (
        <GroupDetailsSidebar
          closePanel={closePanel}
          openContactDetails={(contact) => {
            setNavigatedContacts([...navigatedContacts, contact]);
          }}
          hidden={navigatedContacts.length > 0 || hidden}
        />
      )}

      {sidebarToShow === 'contact' && contact && (
        <ContactDetailsSidebar
          contact={contact}
          closePanel={closePanel}
          openContactDetails={(contact) => {
            setNavigatedContacts([...navigatedContacts, contact]);
          }}
          hidden={navigatedContacts.length > 0 || hidden}
          key={`contact-${contact.id}`}
        />
      )}

      {navigatedContacts.length > 0 && (
        <ContactDetailsSidebar
          contact={navigatedContacts[navigatedContacts.length - 1]}
          closePanel={closePanel}
          openContactDetails={(contact) => {
            setNavigatedContacts([...navigatedContacts, contact]);
          }}
          goBack={() => {
            setNavigatedContacts(
              navigatedContacts.slice(0, navigatedContacts.length - 1)
            );
          }}
          hidden={navigatedContacts.length === 0 || hidden}
          key={`navigated-contact-${navigatedContacts[0].id}-${
            navigatedContacts.length - 1
          }`}
        />
      )}
    </>
  );
});
